import { render, staticRenderFns } from "./MandalaGoalTemplateForm.vue?vue&type=template&id=290146a6&"
import script from "./MandalaGoalTemplateForm.vue?vue&type=script&lang=js&"
export * from "./MandalaGoalTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports